// ── RSVP window ───────────────────────────────────────────────────────────────
// Closed after the September 18, 2026 deadline: Paradiso Events asked us to take
// the RSVP page down so late responses can't slip past the final guest count.
// Anyone still needing to respond contacts Caroline and Michael directly.
//
// Flip to true to reopen — that restores the RSVP tab and button in the navbar,
// the "RSVP Now" button on the home page, the nudge shown after sign-in, and
// the form itself at /rsvp (which otherwise shows a "closed" note instead).
const RSVP_OPEN = false;

export default RSVP_OPEN;
